import React from 'react'
import PageHero from '../components/PageHero'
import PageLayout from '../components/PageLayout'

const CommunityEngagementPage: React.FC = () => {
    return (
        <PageLayout>
            <PageHero title="Community Engagement" image="./img/communityheader.jpg" imageAlt="Community members gathering at a House event" />
            <section className="py-5">
                <div className="container">
                    <p className="lead readable-copy text-center">
                        The House celebrates Black creativity, innovation, and excellence. We create opportunities for people to engage in unique activities,
                        discussions, and advocacy while connecting them with resources and support networks.
                    </p>
                    <p className="readable-copy text-center">
                        We uplift artists, educators, nonprofits, and vendors invested in increasing cross-cultural understanding and advancing racial
                        diversity, equity, and inclusion.
                    </p>
                </div>
            </section>
        </PageLayout>
    )
}

export default CommunityEngagementPage
